import moment from 'moment'
import { cn } from 'app/lib/utils'

/**
 * A date as a torn-off calendar page. `utc` matters: appointment and hygiene
 * dates are date-only values stored at UTC midnight, and formatting those
 * locally renders the day before. Real timestamps, like when a call happened,
 * are local.
 */
export function DateTile({
  date,
  headClass,
  utc,
  className,
}: {
  date: string
  headClass: string
  utc?: boolean
  className?: string
}) {
  const day = utc ? moment.utc(date) : moment(date)
  if (!day.isValid()) return null
  return (
    <div
      className={cn(
        `flex w-14 shrink-0 flex-col overflow-hidden rounded-lg border border-default bg-surface text-center shadow-elevation-1`,
        className,
      )}
    >
      <span className={cn(`py-0.5 text-label-xs uppercase tracking-wide text-on-color`, headClass)}>
        {day.format(`MMM`)}
      </span>
      <span className="py-1 text-ui-md tabular-nums text-strong">{day.format(`D`)}</span>
    </div>
  )
}
